const MIN_LEFT = 500
const MIN_RIGHT = 320

export const computePaneSizes = (
  totalWidth: number,
  desiredRightSize: number,
): [number, number] => {
  const right = Math.max(MIN_RIGHT, Math.min(desiredRightSize, totalWidth - MIN_LEFT))
  const left = Math.max(MIN_LEFT, totalWidth - right)
  return [left, right]
}
